import {
  Chip,
  HStack,
  Pressable,
  Text,
  VStack,
} from '@ayble-health/dashboard-components';
import { Box } from '@chakra-ui/react';
import { LabOrder, LabResultStatus } from '../../../api/types';
import { formatDate } from '../utils';
import { LabOrderMenu } from './LabOrderMenu';
import { LabStatusChip } from './LabStatusChip';

type LabOrderCardProps = {
  labOrder: LabOrder;
  onClick: () => void;
  onAddResult: () => void;
};

export const LabOrderCard = ({
  labOrder,
  onClick,
  onAddResult,
}: LabOrderCardProps) => {
  const isAbnormal = labOrder.result_status === LabResultStatus.OutOfRange;

  return (
    <Box position={'relative'} h={'100%'} minW={'220px'} maxW={'260px'}>
      <Pressable onClick={onClick} h={'100%'} w={'100%'}>
        <VStack
          align={'flex-start'}
          justify={'space-between'}
          gap={4}
          p={3}
          h={'100%'}
          w={'100%'}
          rounded={'lg'}
          bg={'white'}
          borderWidth={1}
          borderColor={'cloud.200'}
          {...(isAbnormal
            ? { borderTopWidth: '4px', borderTopColor: 'plum' }
            : {})}
        >
          <VStack align={'flex-start'} gap={3} w={'100%'}>
            <Text
              fontSize={'sm'}
              fontWeight={'bold'}
              color={'secondary.500'}
              lineHeight={'sm'}
              lineClamp={2}
              minH={'2.5em'}
              // Reserve space so the title doesn't sit under the
              // absolutely-positioned menu button rendered outside this button.
              pr={6}
            >
              {labOrder.lab}
            </Text>

            <HStack gap={2} align={'center'}>
              {labOrder.lab_company && (
                <Chip variant={'neutral'} fontSize={'2xs'}>
                  {labOrder.lab_company}
                </Chip>
              )}
              <Text fontSize={'xs'} color={'bluegrey'}>
                {formatDate(labOrder.created_at ?? undefined, 'MMM D, YYYY')}
              </Text>
            </HStack>
          </VStack>

          <HStack justify={'flex-end'} align={'center'} w={'100%'} mt={'auto'}>
            {labOrder.result_status && (
              <LabStatusChip status={labOrder.result_status} />
            )}
          </HStack>
        </VStack>
      </Pressable>

      <Box position={'absolute'} top={1} right={1} zIndex={1}>
        <LabOrderMenu onAddResult={onAddResult} />
      </Box>
    </Box>
  );
};

export default LabOrderCard;
